<div class="toast-container">
    <div *ngFor="let toast of toasts" class="toast" [@slideInOut] (click)="removeToast(toast.id)">
        <div class="content" [ngClass]="toast.type">
            <span class="message">{{ toast.message }}</span>
            <button class="close-btn" (click)="removeToast(toast.id); $event.stopPropagation()">
                ×
            </button>
        </div>
    </div>
</div>